import { Api } from '@monorepo/shared/apiClient';
import { MutationConfig, useMutation } from 'react-query';

type Input = {
  config?: MutationConfig<
    Api.GenerateFormTemplateFromPdfResponse,
    Api.ErrorResponse
  >;
};

export function useStartGeneratingFormTemplateFromPdf(input?: Input) {
  return useMutation(Api.generateFormTemplateFromPdf, input?.config);
}
